import { BasicButton } from "@certn/cascadia";
import {
  Container,
  Grid,
  Layout,
  SecondaryTopNav,
} from "@certn/cascadia-react";
import { PrimaryButton, Text } from "@certn/cascadia";
import { t } from "i18next";
import { PropsWithChildren, useState } from "react";
import { useNavigate } from "react-router-dom";

import { CancelModal } from "../CancelModal";

interface Props extends PropsWithChildren {
  disableCompletion?: boolean;
  submitting?: boolean;
  onComplete?: () => void;
}

export function CriminalRecordTemplatePageLayout(props: Props) {
  const { disableCompletion, submitting, onComplete, children } = props;

  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleCancel = () => {
    setShowCancelModal(false);
    navigate("/settings/criminal-record-templates");
  };

  return (
    <Layout
      layout="narrow"
      header={
        <SecondaryTopNav
          testID="close-button"
          leftIcon="close"
          onleftIconOnPress={() => setShowCancelModal(true)}
        >
          <BasicButton
            onPress={() => setShowCancelModal(true)}
            isLoading={submitting}
            testID="criminal-record-template-cancel-button"
          >
            {t("Cancel")}
          </BasicButton>
          <PrimaryButton
            onPress={() => onComplete?.()}
            isDisabled={disableCompletion}
            isLoading={submitting}
          >
            {t("Save template")}
          </PrimaryButton>
        </SecondaryTopNav>
      }
    >
      <Container>
        <Text as="h1" style="global/title-medium">
          {t("Create criminal record template")}
        </Text>

        <Grid form>{children}</Grid>
        {showCancelModal && (
          <CancelModal
            onConfirm={handleCancel}
            onClose={() => setShowCancelModal(false)}
            isOpen={showCancelModal}
          />
        )}
      </Container>
    </Layout>
  );
}
